// extracted by mini-css-extract-plugin
module.exports = {"DialogTerm":"Dialog_DialogTerm__LCWcp","WinTable":"Dialog_WinTable___GUyZ","WinShare":"Dialog_WinShare__nK_sl"};